import { render, staticRenderFns } from "./ProfessionalDetailEdit.vue?vue&type=template&id=4d0681a1&scoped=true"
import script from "./ProfessionalDetailEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionalDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalDetailEdit.vue?vue&type=style&index=0&id=4d0681a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0681a1",
  null
  
)

export default component.exports